import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './auth/LoginPage';
import { MfaPage } from './auth/MfaPage';
import { SetPasswordPage } from './auth/SetPasswordPage';
import { RequireAuth } from './auth/RequireAuth';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { VehiclesPage } from './pages/VehiclesPage';
import { VehicleFormPage } from './pages/VehicleFormPage';
import { DriversPage } from './pages/DriversPage';
import { DriverFormPage } from './pages/DriverFormPage';
import { ReportsPage } from './pages/ReportsPage';
import { ManualReviewPage } from './pages/ManualReviewPage';
import { UsersPage } from './pages/UsersPage';
import { AlertRecipientsPage } from './pages/AlertRecipientsPage';
import { HistoryPage } from './pages/HistoryPage';
import { EventDetailPage } from './pages/EventDetailPage';
import { UploadEventPage } from './pages/UploadEventPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/mfa" element={<MfaPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/vehicles" element={<VehiclesPage />} />
        <Route path="/vehicles/new" element={<RequireAuth roles={['ADMIN','OPERADOR']}><VehicleFormPage /></RequireAuth>} />
        <Route path="/vehicles/:id" element={<VehicleFormPage />} />
        <Route path="/drivers" element={<DriversPage />} />
        <Route path="/drivers/new" element={<RequireAuth roles={['ADMIN','OPERADOR']}><DriverFormPage /></RequireAuth>} />
        <Route path="/drivers/:id" element={<DriverFormPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/history/:id" element={<EventDetailPage />} />
        <Route path="/upload" element={<RequireAuth roles={['ADMIN','OPERADOR']}><UploadEventPage /></RequireAuth>} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/admin/manual-review" element={<RequireAuth roles={['ADMIN','OPERADOR']}><ManualReviewPage /></RequireAuth>} />
        <Route path="/admin/users" element={<RequireAuth roles={['ADMIN']}><UsersPage /></RequireAuth>} />
        <Route path="/admin/alert-recipients" element={<RequireAuth roles={['ADMIN']}><AlertRecipientsPage /></RequireAuth>} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
